<vue-page-header
  appName="{{ 'title.applicationName' | translate | async }}"
  pageTitle="{{ 'title.pageNotFound' | translate | async }}"
></vue-page-header>
<app-page-body>{{ 'message.pageNotFound' | translate | async }}</app-page-body>
